export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.7-1048.48",
  commitId: "7101935fc2933fc67b5ebb13bd2b2c73a0c37c2f",
  commitTime: "2026-08-07T10:48:48.000Z",
});
